/**
 * @author Timothy Biörck
 * @description Enum consisting of the different employer types. Set to match the
 * EmployerType enum in backend.
 */

export enum EmployerType {
  COMPANY = 'Företag',
  GOVERNMENT = 'Myndighet',
  MUNICIPALITY = 'Kommun',
  COUNTY = 'Landsting',
  FOREIGN = 'Utländskt företag'
}